<div class="d-flex justify-content-between">
  <app-breadcrumb id="MainActivity" *ngIf="qualityService.refereshBreadCrumb"></app-breadcrumb>
  <div class="d-flex gap-4 align-items-center">
    <div class="">
      <span [ngStyle]="statusAppearance(dv.status)" class="crDetail-status1 " *ngIf="dv != undefined">
        Status&nbsp;:&nbsp; <span>{{ this.dv.status }}</span>
      </span>
    </div>
    <div class="d-flex gap-2">
      <div class="d-flex align-items-center justify-content-center communication_cta pointer"
        (click)="openExportPopup()" (keydown.enter)="openExportPopup()" matTooltip="Report">
        <img src="../../../assets/img/cr_module/pdf.svg" width="22px" height="20px" alt="" />
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta  pointer"
        matTooltip="Dependent of">
        <img src="../../../assets/img/qms_img/dependency.svg" width="14px" height="14px" alt=""
          (click)="openDependentsPopup()" (keydown.enter)="openDependentsPopup()" />
      </div>
      <div *ngIf="message.isTopicAdministrator">
        <div class="d-flex align-items-center justify-content-center communication_cta pointer"
          matTooltip="Communication">
          <img src="../../../assets/img/cr_module/communication.svg" width="14px" height="14px" alt=""
            (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta communication-icon pointer"
        matTooltip="Tag to Home" (click)="openTag()" (keydown.enter)="openTag()">
        <img src="../../../assets/img/tags.png" width="17px" height="19px" alt="" />
      </div>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex mt-2 mb-2">

  <div class="" style="margin-right:auto;">
    <app-task-stage-statistics *ngIf="qualityService.refereshBreadCrumb"></app-task-stage-statistics>
  </div>

  <div class="" style="margin-right:1%;align-content:center;"
    *ngIf=" qualityService.activity.status == 'In Progress' && parallelWorkflowList?.length==0 && (qualityService.activity.owner == qualityService.loggeduserid)">

    <div matTooltip="Add Workflow" (click)="openAddWorkflow()" (keydown.enter)="openAddWorkflow()"
      style="border: 0.75px solid rgba(222, 235, 254, 0.8980392157); border-radius: 100px; width: 36px; height: 36px;"
      class="d-flex justify-content-center align-items-center actions_cta pointer">
      <a>
        <img title="Switch User" src="..//..//../assets/img/parallel workflow.svg" width="20" height="20" alt="switch">
      </a>
    </div>
  </div>

  <div class="">
    <app-activity-dynamic-button></app-activity-dynamic-button>
  </div>
</div>

<div class="tab">
  <mat-tab-group mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
    (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex" #tabsGroup>

    <mat-tab label="Deviation">
      <ng-template mat-tab-label>
        <span><i class='fa-solid fa-file-pen' style="font-size: 20px;"
            aria-hidden="true"></i></span>&nbsp;<span>{{qualityService.moduleFullName}}</span>
      </ng-template>

      <div *ngIf="dynamicLabel">
        <fieldset class="border p-2 fieldsetStyle">
          <legend class="float-none w-auto p-2"><span class="" style="font-size: 14px;color: #cfcfcf;">Details</span>
          </legend>
          <div class="row">
            <div class="col-md-3">
              <div>
                <!-- Deviation ID -->
                <label for="email"> {{dynamicLabel['DV_ID'].fieldName}} </label>
                <span style="float:right" *ngIf="dynamicLabel['DV_ID'].fieldNotes"
                  [matTooltip]="dynamicLabel['DV_ID'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                    width="18" height="18"></span>
              </div>
              <input class="input-filed-continers" type="text" [(ngModel)]="dv.dvId" [disabled]="true">
            </div>

            <div class="col-md-3">
              <div>
                <!-- Status -->
                <label for="email"> {{dynamicLabel['STATUS'].fieldName}} </label>
                <span style="float:right" *ngIf="dynamicLabel['STATUS'].fieldNotes"
                  [matTooltip]="dynamicLabel['STATUS'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                    width="18" height="18"></span>
              </div>
              <input class="input-filed-continers" type="text" [(ngModel)]="dv.status" [disabled]="true">
            </div>

            <div class="col-md-3">
              <div>
                <!-- Initiated By -->
                <label for="email"> {{dynamicLabel['INITIATED_BY_USER_NAME'].fieldName}} </label>
                <span style="float:right" *ngIf="dynamicLabel['INITIATED_BY_USER_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['INITIATED_BY_USER_NAME'].fieldNotes"><img [src]="qualityService.noteIcon"
                    alt="note" width="18" height="18"></span>
              </div>
              <input class="input-filed-continers" type="text" [(ngModel)]="dv.initiatedByUserName" [disabled]="true">
            </div>

            <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable=='Y'">
              <div>
                <label id="department-validation" for="email">
                  <!-- Department -->
                  {{dynamicLabel['DEPT_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.departmentValue" (closed)="departmentSearchText=''"
                (click)="focusSearch('focus-dept')" (keydown.enter)="focusSearch('focus-dept')"
                [ngClass]="{'odd-item-mat-select':isDepartmentOdd==qualityService.dvPageAllDropdownValues.departmentValue}"
                [disabled]="isFrozen">
                <input type="search" id="focus-dept" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDepartmentCodeSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :departmentSearchText"
                  (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <label id="owner-validation" for="email">
                  <!-- Owner -->
                  {{dynamicLabel['OWNER_USER_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(dv.status,'owner')" for="email">
                  <a (click)="openswitchuser('Owner')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" height="25"
                      alt="switch">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.dvPageAllDropdownValues.ownerValue"
                (closed)="ownerSearchText=''" (click)="focusSearch('focus-owner')"
                (keydown.enter)="focusSearch('focus-owner')"
                [ngClass]="{'odd-item-mat-select':isOwnerOdd==qualityService.dvPageAllDropdownValues.ownerValue}"
                [disabled]="isUsersLock">
                <input type="search" id="focus-owner" class="dropdownsearchstyle" [(ngModel)]="ownerSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onOwnerSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of ownerDropdown| assessmentSearch :ownerSearchText"
                  (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp"
                  [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <label id="deviationType-validation" for="email">
                  {{dynamicLabel['DEVIATION_TYPE']?.fieldName}}
                </label>
                <span class="mandatory-symbol" *ngIf="isTypeMandatory">*</span>&nbsp;
                <span class="qms-risk-icon" for="risk" style="padding: 2px;"
                  [matTooltip]="'Update ' + dynamicLabel['DEVIATION_TYPE']?.fieldName" [class.disabled]="isFrozen"
                  (click)="openUpdateType()" (keydown.enter)="openUpdateType()" *ngIf="showUpdateType">
                  <svg width="20" height="20" fill="#000000" viewBox="0 0 36 36" version="1.1"
                    preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M19.5,28.1h-2.9c-0.5,0-0.9-0.3-1-0.8l-0.5-1.8c-0.2-0.1-0.2-0.1-0.4-0.2l-1.6,0.9c-0.4,0.2-0.9,0.2-1.2-0.2l-2.1-2.1 c-0.3-0.3-0.4-0.8-0.2-1.2l0.9-1.6c-0.1-0.2-0.1-0.2-0.2-0.4l-1.8-0.5c-0.4-0.1-0.8-0.5-0.8-1v-2.9c0-0.5,0.3-0.9,0.8-1l1.8-0.5 c0.1-0.2,0.1-0.2,0.2-0.4l-0.9-1.6c-0.2-0.4-0.2-0.9,0.2-1.2l2.1-2.1c0.3-0.3,0.8-0.4,1.2-0.2l1.6,0.9c0.2-0.1,0.2-0.1,0.4-0.2 l0.5-1.8c0.1-0.4,0.5-0.8,1-0.8h2.9c0.5,0,0.9,0.3,1,0.8l0.5,1.8c0.2,0.1,0.2,0.1,0.4,0.2l1.6-0.9c0.4-0.2,0.9-0.2,1.2,0.2 l2.1,2.1c0.3,0.3,0.4,0.8,0.2,1.2l-0.9,1.6c0.1,0.2,0.1,0.2,0.2,0.4l1.8,0.5c0.4,0.1,0.8,0.5,0.8,1v2.9c0,0.5-0.3,0.9-0.8,1 l-1.8,0.5c-0.1,0.2-0.1,0.2-0.2,0.4l0.9,1.6c0.2,0.4,0.2,0.9-0.2,1.2l-2.1,2.1c-0.3,0.3-0.8,0.4-1.2,0.2l-1.6-0.9 c-0.2,0.1-0.2,0.1-0.4,0.2l-0.5,1.8C20.3,27.8,19.9,28.1,19.5,28.1z M17.3,26.1h1.4l0.5-2.1l0.5-0.2c0.4-0.1,0.7-0.3,1.1-0.4 l0.5-0.3l1.9,1.1l1-1l-1.1-1.9l0.3-0.5c0.2-0.3,0.3-0.7,0.4-1.1l0.2-0.5l2.1-0.5v-1.4L24,16.8l-0.2-0.5c-0.1-0.4-0.3-0.7-0.4-1.1 l-0.3-0.5l1.1-1.9l-1-1l-1.9,1.1l-0.5-0.3c-0.3-0.2-0.7-0.3-1.1-0.4L19.2,12l-0.5-2.1h-1.4L16.8,12l-0.5,0.2 c-0.4,0.1-0.7,0.3-1.1,0.4l-0.5,0.3l-1.9-1.1l-1,1l1.1,1.9l-0.3,0.5c-0.2,0.3-0.3,0.7-0.4,1.1L12,16.8l-2.1,0.5v1.4l2.1,0.5 l0.2,0.5c0.1,0.4,0.3,0.7,0.4,1.1l0.3,0.5l-1.1,1.9l1,1l1.9-1.1l0.5,0.3c0.3,0.2,0.7,0.3,1.1,0.4l0.5,0.2L17.3,26.1z M27.1,19.5 L27.1,19.5L27.1,19.5z">
                      </path>
                      <path
                        d="M18,22.3c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3S20.4,22.3,18,22.3z M18,15.7 c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3S19.3,15.7,18,15.7z">
                      </path>
                      <path
                        d="M18,2c-0.6,0-1,0.4-1,1s0.4,1,1,1c7.7,0,14,6.3,14,14s-6.3,14-14,14S4,25.7,4,18c0-2.8,0.8-5.5,2.4-7.8v1.2 c0,0.6,0.4,1,1,1s1-0.4,1-1v-5h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8C3.1,11.1,2,14.5,2,18c0,8.8,7.2,16,16,16s16-7.2,16-16 S26.8,2,18,2z">
                      </path>
                      <rect width="36" height="36" fill-opacity="0"></rect>
                    </g>
                  </svg>
                </span>
              </div>
              <mat-select matInput placeholder="Select"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.deviationTypeValue" (closed)="dvTypeSearchText=''"
                (click)="focusSearch('focus-type')" (keydown.enter)="focusSearch('focus-type')"
                [ngClass]="{'odd-item-mat-select':isDvTypeOdd==qualityService.dvPageAllDropdownValues.deviationTypeValue}"
                [disabled]="showUpdateType || isFrozen">
                <input type="search" id="focus-type" class="dropdownsearchstyle" [(ngModel)]="dvTypeSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDeviationTypeSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of dvTypeDropdown | assessmentSearch : dvTypeSearchText"
                  (onSelectionChange)="onDeviationTypeSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-md-6" *ngIf="qualityService.activity.typeUpdateJustification">
              <div>
                <label for="email" id="justification">
                  {{dynamicLabel['CHANGE_TYPE_CODE']?.fieldName}}&nbsp;{{dynamicLabel['TYPE_UPDATE_JUSTIFICATION']?.fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                (ngModelChange)="onNgModelChange($event,'justification')" [disabled]="true"
                [(ngModel)]="qualityService.activity.typeUpdateJustification"
                (input)="limitCharacters($event, 'TYPE_UPDATE_JUSTIFICATION')"></textarea>
            </div>
            <div class="col-md-3" *ngIf="dynamicLabel['DEVIATION_CRITICALITY'].isRemovable != 'Y'">
              <div>
                <label id="deviationCriticality-validation" for="email">
                  <!-- Deviation Criticality -->
                  {{dynamicLabel['DEVIATION_CRITICALITY'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>&nbsp;
                <span style="float:right" *ngIf="dynamicLabel['DEVIATION_CRITICALITY'].fieldNotes"
                  [matTooltip]="dynamicLabel['DEVIATION_CRITICALITY'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.deviationCriticality"
                (closed)="criticalitySearchText=''" (click)="focusSearch('focus-criticality')"
                (keydown.enter)="focusSearch('focus-criticality')"
                [ngClass]="{'odd-item-mat-select':isCriticalityOdd==qualityService.dvPageAllDropdownValues.deviationCriticality}"
                [disabled]="showUpdateType">
                <input type="search" id="focus-criticality" class="dropdownsearchstyle"
                  [(ngModel)]="criticalitySearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDeviationCriticalitySelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of criticalityDropdown | assessmentSearch :criticalitySearchText"
                  (onSelectionChange)="onDeviationCriticalitySelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <label id="requestedAt-validation" for="email">
                  <!-- Requested At -->
                  {{dynamicLabel['REQUESTED_AT'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
                  [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                    width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select"
                [matTooltip]="qualityService.dvPageAllDropdownValues.requestedAtValue"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.requestedAtValue"
                (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested')"
                (keydown.enter)="focusSearch('focus-requested')"
                [ngClass]="{'odd-item-mat-select':isRequestedAtOdd==qualityService.dvPageAllDropdownValues.requestedAtValue}"
                [disabled]="isFrozen">
                <input type="search" id="focus-requested" class="dropdownsearchstyle"
                  [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onRequestedAtSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch :requestedAtSearchText"
                  (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp"
                  [matTooltip]="item.displayExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-6" *ngIf="qualityService.dvPageAllDropdownValues.requestedAtValue">
              <div>
                <label id="coreBusinessArea-validation" for="email">
                  {{((this.businessAreaName ?? ' ') + ' ' + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                </label>
                <span class="mandatory-symbol">*</span>
              </div>
              <mat-select matInput #businessArea multiple placeholder="Select"
                *ngIf="coreBusinessAreaNameDropdown.length>0" [disabled]="isFrozen"
                [matTooltip]="qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue"
                (closed)="coreBusinessSearchText=''" (click)="focusSearch('focusSearch')"
                (keydown.enter)="focusSearch('focusSearch')">
                <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="coreBusinessSearchText"
                  matInput placeholder="search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected"
                    (change)="toggleAllSelection('businessArea')">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of coreBusinessAreaNameDropdown| assessmentSearch :coreBusinessSearchText"
                  [value]="item1.valueExp" (onSelectionChange)="onCoreBusinessAreaNameSelect($event,item1)"
                  [matTooltip]="item1.displayExp">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                *ngIf="coreBusinessAreaNameDropdown.length==0" [disabled]="isFrozen"
                (ngModelChange)="onNgModelChange($event,'coreBusinessArea-validation')"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue"
                (input)="limitCharacters($event, 'REQUESTED_AT')"
                [matTooltip]="qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue"></textarea>
            </div>

            <div class="col-md-3" F [hidden]="this.dv.qaUser==0">
              <div><label id="qaUser-validation" for="email">
                  <!-- QA User -->{{dynamicLabel['QA_USER_NAME'].fieldName}}
                </label><span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(dv.status,'qa')" for="email">
                  <a (click)="openswitchuser('QA')"><img title="Switch User" src="..//..//../assets/img/user-switch.png"
                      alt="switch" width="25" height="25"></a></label>
                <span style="float:right" *ngIf="dynamicLabel['QA_USER_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['QA_USER_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                    width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.dvPageAllDropdownValues.qaUserValue"
                (closed)="qaSearchText=''" (click)="focusSearch('focus-qa')" (keydown.enter)="focusSearch('focus-qa')"
                [ngClass]="{'odd-item-mat-select':isQAOdd==qualityService.dvPageAllDropdownValues.qaUserValue}"
                [disabled]="isUsersLock">
                <input type="search" id="focus-qa" class="dropdownsearchstyle" [(ngModel)]="qaSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onQaUserSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of qaDropdown| assessmentSearch :qaSearchText"
                  (onSelectionChange)="onQaUserSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="dynamicLabel['REASON_FOR_DEVIATION_CODE'].isRemovable=='Y'">
              <div>
                <label id="reasonForDeviation-validation" for="email">
                  <!-- Reason for Deviation -->
                  {{dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldNotes"
                  [matTooltip]="dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput multiple placeholder="Select" #reason
                [(ngModel)]="qualityService.dvPageAllDropdownValues.reasonForDeviationValue" (closed)="dvSearchText=''"
                (click)="focusSearch('f-r-f-d')" (keydown.enter)="focusSearch('f-r-f-d')" [disabled]="isFrozen">
                <input type="search" id="f-r-f-d" class="dropdownsearchstyle" [(ngModel)]="dvSearchText" matInput
                  placeholder="search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="isAllReasonSelected" (change)="toggleAllSelection('reason')">
                    Select All
                  </mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of reasonForDvDropDown | multiAssessmentSearchPipe :dvSearchText"
                  [value]="item1.valueExp" (onSelectionChange)="onReasonForDvSelect($event,item1)">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.dvPageAllDropdownValues.reasonForDeviationValue.includes('Others')">
              <div>
                <label id="reasonForChangeIfOthers-validation" for="email">
                  {{dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldName}} if Others
                </label>
                <span class="mandatory-symbol">*</span>
              </div>
              <textarea id="reasonForChangeIfOthers" type="text" class="input-filed-textarea" rows="4" cols="50"
                [(ngModel)]="qualityService.activity.reasonForDeviation" [disabled]="isFrozen"
                (ngModelChange)="onNgModelChange($event,'reasonForChangeIfOthers-validation')"
                (input)="limitCharacters($event, 'REASON_FOR_DEVIATION')"></textarea>
            </div>

            <div class="col-md-3" [hidden]="this.dv.departmentHead==0">
              <div><label id="dhUser-validation"
                  for="email">{{dynamicLabel['DEPARTMENT_HEAD_USER_NAME'].fieldName}}</label>
                <!-- QA User -->
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(dv.status,'dh')" id="dh-validation"
                  for="email">
                  <a (click)="openswitchuser('Department Head')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEPARTMENT_HEAD'].fieldNotes"
                  [matTooltip]="dynamicLabel['DEPARTMENT_HEAD'].fieldNotes"><img [src]="qualityService.noteIcon"
                    alt="note" width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.departmentHeadUserValue"
                (closed)="departmentHeadSearchText=''" (click)="focusSearch('dh-focus')"
                (keydown.enter)="focusSearch('dh-focus')"
                [ngClass]="{'odd-item-mat-select':isDhOdd==qualityService.dvPageAllDropdownValues.departmentHeadUserValue}"
                [disabled]="isUsersLock">
                <input type="search" id="dh-focus" class="dropdownsearchstyle" [(ngModel)]="departmentHeadSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentHeadDropdown | assessmentSearch :departmentHeadSearchText"
                  (onSelectionChange)="onDhUserSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </fieldset>

        <fieldset class="border p-2 fieldsetStyle">
          <legend class="float-none w-auto p-2"><span class="" style="font-size: 14px;color: #cfcfcf;">Date</span>
          </legend>
          <div class="row">
            <div class="col-md-2">
              <div>
                <label for="email">
                  <!-- Initiated On -->
                  {{dynamicLabel['CREATED_ON'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['CREATED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['CREATED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.createdOn"
                [disabled]="true" (ngModelChange)="checkDateDifference()">
            </div>

            <div class="col-md-2" [hidden]="dynamicLabel['DEVIATION_OCCURED_ON'].isRemovable=='Y'">
              <div><label for="email" id="deviationOccuredOn-validation">
                  <!-- Deviation Occurred On -->
                  {{dynamicLabel['DEVIATION_OCCURED_ON'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['DEVIATION_OCCURED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['DEVIATION_OCCURED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="$past_present_config" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.deviationOccuredOn"
                (ngModelChange)="onNgModelChange($event,'deviationOccuredOn-validation'); " [disabled]="isFrozen">
            </div>

            <div class="col-md-2" [hidden]="dynamicLabel['DEVIATION_IDENTIFIED_ON'].isRemovable=='Y'">
              <div>
                <label for="email" id="deviationIdentifiedOn-validation">
                  <!-- Deviation Identified On -->
                  {{dynamicLabel['DEVIATION_IDENTIFIED_ON'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['DEVIATION_IDENTIFIED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['DEVIATION_IDENTIFIED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="$identified_on_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.deviationIdentifiedOn"
                (ngModelChange)="onDeviationIdentifiedOnChange($event)"
                [disabled]="!qualityService.activity.deviationOccuredOn || isFrozen">
            </div>

            <div class="col-md-2" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable=='Y'">
              <div>
                <label for="email" id="expectedToBeStartedOn-validation">
                  <!-- Expected to be Started On -->
                  {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.expectedToBeStartedOn"
                (ngModelChange)="onNgModelChange($event,'expectedToBeStartedOn-validation'); onExpectedToBeStartedOnChange()"
                [disabled]="dv.expectedClosureFromSettings=='Y' || isFrozen">
            </div>

            <div class="col-md-2">
              <div><label for="email" id="expcetedClosureOn-validation">
                  <!-- Expected Closure Date -->
                  {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="$expected_closure_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.expcetedClosureOn"
                (ngModelChange)="onNgModelChange($event,'expcetedClosureOn-validation')" [disabled]="isFrozen">
            </div>

            <div class="col-md-2">
              <div>
                <label for="email">
                  <!-- Started On -->
                  {{dynamicLabel['STARTED_ON'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['STARTED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['STARTED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.startedOn"
                [disabled]="true">
            </div>

            <div class="col-md-2 field-styles1">
              <div>
                <label for="email">
                  <!--Completed On-->{{dynamicLabel['COMPLETED_ON'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['COMPLETED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['COMPLETED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.completedOn"
                [disabled]="true">
            </div>
            <div class="col-md-6" *ngIf="isDiffMoreThan48Hrs"
              [hidden]="dynamicLabel['JUSTIFICATION_FOR_DELAY_LOGGING'].isRemovable=='Y'">
              <div>
                <!-- Delay Logging -->
                <label id="justificationfordv-validation" for="email">
                  {{dynamicLabel['JUSTIFICATION_FOR_DELAY_LOGGING']?.fieldName}}
                </label>
                <span *ngIf="markDelayLoggingAsMandatory" class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['JUSTIFICATION_FOR_DELAY_LOGGING']?.fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION_FOR_DELAY_LOGGING']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.justificationForDelayLogging"
                    [config]="excludeButtons" [spellcheck]="true" [disabled]="isFrozen"
                    (ngModelChange)="onStEditorChange($event,'justificationfordv-validation')"
                    (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="isFrozen ? openEditor('Justification For Delay Logging', 'eye') : openEditor('Justification For Delay Logging', 'edit')"
                  (click)="isFrozen? openEditor('Justification For Delay Logging', 'eye') : openEditor('Justification For Delay Logging', 'edit')">
                  <i *ngIf="!isFrozen" class="far fa-edit"></i>
                  <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset class="border p-2 fieldsetStyle">
          <legend class="float-none w-auto p-2"><span class=""
              style="font-size: 14px;color: #cfcfcf;">Description</span></legend>
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <label id="shortDescription-validation" for="email ">
                  <!--Short Description-->{{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
                  <span class="mandatory-symbol">*</span>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
                  [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <input class="form-control" type="text" [(ngModel)]="qualityService.activity.shortDescription"
                  [matTooltip]="qualityService.activity.shortDescription"
                  (ngModelChange)="onNgModelChange($event,'shortDescription-validation')"
                  (input)="limitCharacters($event, 'SHORT_DESCRIPTION')" [disabled]="isFrozen">
              </div>
            </div>

            <div class="col-md-6">
              <div class="row">
                <label id="dvDescription-validation" for="email">
                  <!-- Deviation Description  -->{{dynamicLabel['DV_DESCRIPTION'].fieldName}}
                  <span class="mandatory-symbol">*</span>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DV_DESCRIPTION'].fieldNotes"
                  [matTooltip]="dynamicLabel['DV_DESCRIPTION'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.dvDescription" [config]="config" [spellcheck]="true"
                    [disabled]="isFrozen" (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange($event,'dvDescription-validation')"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (click)="isFrozen ? openEditor('Deviation Description', 'eye') : openEditor('Deviation Description', 'edit')"
                  (keydown.enter)="isFrozen ? openEditor('Deviation Description', 'eye') : openEditor('Deviation Description', 'edit')">
                  <i *ngIf="!isFrozen" class="far fa-edit"></i>
                  <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="row field-styles1">
          <div class="col-md-2" *ngIf="this.qualityService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
            <div>
              <label for="email ">
                <!-- Is Effectiveness Check Mandatory? -->{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"
                [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.effectivenessCheckReqd"
              [disabled]="isFrozen">
              <span class="active-inActive-container" *ngIf="dv.effectivenessCheckReqd==true"
                [ngStyle]="dv.effectivenessCheckReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
              <span *ngIf="dv.effectivenessCheckReqd==false"
                [ngStyle]="dv.effectivenessCheckReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>
          <div class="col-md-2" *ngIf="qualityService.selectedGroupDetailData.preliminaryActionEnabled == 'Y'">
            <div>
              <label for="email ">
                {{dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldNotes"
                [matTooltip]="dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
              </span>
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.preActionItemsReqd"
              [disabled]="dv.startedOn || isFrozen">
              <span class="active-inActive-container"
                [ngStyle]="{ color: qualityService.activity.preActionItemsReqd ? 'green' : 'red' }">
                {{ qualityService.activity.preActionItemsReqd ? 'Yes' : 'No' }}
              </span>
            </mat-slide-toggle>
          </div>
          <div class="col-md-2">
            <div>
              <label for="email ">
                <!-- Action Items Required -->
                {{dynamicLabel['ACTION_ITEMS_REQD'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes"
                [matTooltip]="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.actionItemsReqd"
              [disabled]="dv.startedOn || isFrozen">
              <span class="active-inActive-container" *ngIf="dv.actionItemsReqd==true"
                [ngStyle]="dv.actionItemsReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
              <span *ngIf="dv.actionItemsReqd==false"
                [ngStyle]="dv.actionItemsReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>

          <div class="col-md-2">
            <div>
              <label for="email ">
                <!-- Detailed Investigation Required -->{{dynamicLabel['INVESTIGATION_REQD'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['INVESTIGATION_REQD'].fieldNotes"
                [matTooltip]="dynamicLabel['INVESTIGATION_REQD'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.investigationReqd"
              [disabled]="isFrozen" (change)="onInvestigationChange($event)">
              <span class="active-inActive-container" *ngIf="dv.investigationReqd==true"
                [ngStyle]="dv.investigationReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
              <span *ngIf="dv.investigationReqd==false"
                [ngStyle]="dv.investigationReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>

          <div class="col-md-2" *ngIf="this.qualityService.selectedGroupDetailData.isRiskCalculationReqd=='Y'">
            <div>
              <label for="email">
                <!-- Is Risk Calculation Reqd? -->{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
                [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.isRiskCalculationReqd"
              [disabled]="isFrozen">
              <span *ngIf="qualityService.activity.isRiskCalculationReqd==true"
                [ngStyle]="qualityService.activity.isRiskCalculationReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
              <span *ngIf="qualityService.activity.isRiskCalculationReqd==false"
                [ngStyle]="qualityService.activity.isRiskCalculationReqd==false?{'color':'red'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>
          <div class="col-md-2 d-flex align-items-center" *ngIf="qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'
            && qualityService.activity.isRiskCalculationReqd
            && qualityService.activity.finalRiskScore">

            <div class="d-flex align-items-center gap-4">
              <div class="qms-risk-icon" [matTooltip]="'Risk Status : ' + qualityService.activity.finalRiskStatus">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  stroke="#0f3659">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path d="M6.87988 18.1501V16.0801" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round">
                    </path>
                    <path d="M12 18.15V14.01" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M17.1201 18.1499V11.9299" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round">
                    </path>
                    <path d="M17.1199 5.8501L16.6599 6.3901C14.1099 9.3701 10.6899 11.4801 6.87988 12.4301"
                      stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M14.1899 5.8501H17.1199V8.7701" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"></path>
                    <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                      stroke="#0f3659" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </g>
                </svg>
              </div>

              <div class="qms-risk-icon" [matTooltip]="'Navigate to Risk Assessment'" (click)="navigateToRisk()"
                (keydown.enter)="navigateToRisk()">
                <svg width="20" height="20" fill="#0f3659" viewBox="0 0 35 35" data-name="Layer 2" id="Layer_2"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M21.81,34.75H21.5A3.8,3.8,0,0,1,18,31.58L16,20.12A1.36,1.36,0,0,0,14.88,19L3.42,17a3.84,3.84,0,0,1-.56-7.42L29.66.46h0a3.84,3.84,0,0,1,4.88,4.88l-9.11,26.8A3.79,3.79,0,0,1,21.81,34.75ZM30.47,2.83,3.66,11.94a1.34,1.34,0,0,0,.2,2.59l11.46,2a3.85,3.85,0,0,1,3.11,3.11l2,11.46a1.34,1.34,0,0,0,2.59.2L32.17,4.53a1.34,1.34,0,0,0-1.7-1.7Z">
                    </path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row field-styles1" *ngIf="message.showCRDetailsSection">
        <div class="col-md-12">
          <div class="menu-container">
            <div class="row menu-row-container">
              <div class="col-sm-8 gridName-container">
                <span class="gridName">{{qualityService.moduleFullName}}&nbsp; Details</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="dynamicLabel">
          <div class="col-md-4" [hidden]="dynamicLabel['SCOPE'].isRemovable=='Y'">
            <div class="row">
              <label id="scope-validation" for="email">
                <!-- Scope -->{{dynamicLabel['SCOPE'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['SCOPE'].fieldNotes"
                [matTooltip]="dynamicLabel['SCOPE'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qualityService.activity.scope" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit"
                (click)="isFrozen ? openEditor('Scope', 'eye') : openEditor('Scope', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Scope', 'eye') : openEditor('Scope', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>

          <div class="col-md-4" [hidden]="dynamicLabel['INITIAL_ASSESSMENT'].isRemovable=='Y'">
            <div class="row">
              <label id="initialAssessment-validation" for="email">
                <!-- Initial Assessment -->{{dynamicLabel['INITIAL_ASSESSMENT'].fieldName}}
                <span class="mandatory-symbol">*</span>
              </label>
              <span style="float:right" *ngIf="dynamicLabel['INITIAL_ASSESSMENT'].fieldNotes"
                [matTooltip]="dynamicLabel['INITIAL_ASSESSMENT'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qualityService.activity.initialAssessment" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)"
                  (ngModelChange)="onStEditorChange($event,'initialAssessment-validation')"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit"
                (click)="isFrozen ? openEditor('Initial Assessment', 'eye') : openEditor('Initial Assessment', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Initial Assessment', 'eye') : openEditor('Initial Assessment', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div>
              <label id="rootCauseCategory-validation" for="email">
                <!-- Root Cause Category -->{{dynamicLabel['ROOT_CAUSE_CATEGORY'].fieldName}}
              </label>
              <span class="mandatory-symbol">*</span>
              <span style="float:right" *ngIf="dynamicLabel['ROOT_CAUSE_CATEGORY'].fieldNotes"
                [matTooltip]="dynamicLabel['ROOT_CAUSE_CATEGORY'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
              </span>
            </div>
            <mat-select matInput multiple placeholder="Select" #rootCause
              [(ngModel)]="qualityService.dvPageAllDropdownValues.dvRootCauseCategory"
              (closed)="rootCauseCategorySearchText = ''" (click)="focusSearch('focus-root-cause')"
              (keydown.enter)="focusSearch('focus-root-cause')" [disabled]="isFrozen">
              <input type="search" id="focus-root-cause" class="dropdownsearchstyle"
                [(ngModel)]="rootCauseCategorySearchText" matInput placeholder="search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAllRootCauseSelected" (change)="toggleAllSelection('rootCause')">
                  Select All
                </mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of rootCauseDropdown | multiAssessmentSearchPipe : rootCauseCategorySearchText"
                [value]="item1.valueExp" (onSelectionChange)="onRootCauseCategorySelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>

          <div class="col-md-4 field-styles1" [hidden]="dynamicLabel['ROOT_CAUSE_ANALYSIS'].isRemovable=='Y'">
            <div class="row">
              <label id="rootCauseSummary-validation" for="email">
                <!-- Root Cause Analysis -->{{dynamicLabel['ROOT_CAUSE_ANALYSIS'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['ROOT_CAUSE_ANALYSIS'].fieldNotes"
                [matTooltip]="dynamicLabel['ROOT_CAUSE_ANALYSIS'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
              </span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qualityService.activity.rootCauseAnalysis" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)">
                </st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit"
                (click)="isFrozen ? openEditor('Root Cause Analysis', 'eye') : openEditor('Root Cause Analysis', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Root Cause Analysis', 'eye') : openEditor('Root Cause Analysis', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>

          <div class="col-md-4 field-styles1" [hidden]="dynamicLabel['IMPACT_ASSESSMENT'].isRemovable=='Y'">
            <div class="row">
              <label id="impactAssessment-validation" for="email">
                <!-- Impact Assessment  -->{{dynamicLabel['IMPACT_ASSESSMENT'].fieldName}}
                <span class="mandatory-symbol">*</span>
              </label>
              <span style="float:right" *ngIf="dynamicLabel['IMPACT_ASSESSMENT'].fieldNotes"
                [matTooltip]="dynamicLabel['IMPACT_ASSESSMENT'].fieldNotes">
                <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qualityService.activity.impactAssessment" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)"
                  (ngModelChange)="onStEditorChange($event,'impactAssessment-validation')"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit"
                (click)="isFrozen ? openEditor('Impact Assessment', 'eye') : openEditor('Impact Assessment', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Impact Assessment', 'eye') : openEditor('Impact Assessment', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>

          <div class="col-md-4 field-styles1" [hidden]="dynamicLabel['CONCLUSION'].isRemovable=='Y'">
            <div class="row"><label id="conclusion-validation" for="email">
                <!-- Conclusion -->{{dynamicLabel['CONCLUSION'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['CONCLUSION'].fieldNotes"
                [matTooltip]="dynamicLabel['CONCLUSION'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                  width="18" height="18"></span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-11"><st-editor [(ngModel)]="qualityService.activity.conclusion"
                  [config]="config" [spellcheck]="true" [disabled]="isFrozen" (paste)="onPaste($event)"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit"
                (click)="isFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <fieldset class="border p-2 crFieldsetStyle">
        <legend class="float-none w-auto p-2">
          <span class="" style="font-size: 14px;color: #cfcfcf;">More Info</span>
        </legend>
        <div class="row field-styles1" style="margin-top: -1%;">
          <div class="col-md-2" *ngIf="qualityService.activity.lastActionOn">
            <div>
              <label for="email">
                {{dynamicLabel['LAST_ACTION_ON']?.fieldName}}
              </label>
            </div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.lastActionOn"
              [disabled]="true">
          </div>
          <div class="col-md-2" *ngIf="qualityService.activity.lastActionByUser">
            <div>
              <label for="email">
                {{dynamicLabel['LAST_ACTION_BY_USER']?.fieldName}}
              </label>
            </div>
            <input type="text" class="input-filed-continers" [(ngModel)]="qualityService.activity.lastActionByUser"
              [disabled]="true">
          </div>
          <div class="col-md-2" *ngIf="qualityService.activity.lastActionComments">
            <div>
              <label for="email">
                {{dynamicLabel['LAST_ACTION_COMMENTS']?.fieldName}}
              </label>
            </div>
            <input type="text" class="input-filed-continers" [(ngModel)]="qualityService.activity.lastActionComments"
              [disabled]="true">
          </div>
        </div>
      </fieldset>
      <div class="ActivityPage" id="Additionaldetail" style="margin-top: 15px;">
        <app-flexible-fields #flexible [from]="'Details'"></app-flexible-fields>
      </div>

    </mat-tab>
    <div *ngFor="let tabPage of message.tabPagesOrderlist; let idx = index;">
      <mat-tab label="Investigation" *ngIf="showInvestigationTab && tabPage=='Investigation'">
        <ng-template mat-tab-label>
          <span><i class="fa-solid fa-magnifying-glass" style="font-size: 20px;"></i></span>&nbsp;
          <span>Investigation</span>
        </ng-template>
        <div>
          <div class="row field-styles1">
            <div class="col-md-4">
              <label id="investigationPlan-validation" for="email">
                {{dynamicLabel['INVESTIGATION_PLAN'].fieldName}}
              </label>
              <span class="mandatory-symbol">*</span>
              <div class="row">
                <div class="hideToolbar col-sm-11"><st-editor [disabled]="isFrozen"
                    [(ngModel)]="qualityService.activity.investigationPlan" [config]="config" [spellcheck]="true"
                    (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange($event,'investigationPlan-validation')"></st-editor></div>
                <div class="col-sm-1 angular-editor-edit"
                  (click)="isFrozen ? openEditor('Investigation Plan', 'eye') : openEditor('Investigation Plan', 'edit')"
                  (keydown.enter)="isFrozen ? openEditor('Investigation Plan', 'eye') : openEditor('Investigation Plan', 'edit')">
                  <i *ngIf="!isFrozen" class="far fa-edit"></i>
                  <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row"><label id="investigationDetails-validation"
                  for="email">{{dynamicLabel['INVESTIGATION_DETAILS'].fieldName}}</label>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11"><st-editor [disabled]="isFrozen"
                    [(ngModel)]="qualityService.activity.investigationDetails" [config]="config" [spellcheck]="isFrozen"
                    (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange($event,'investigationDetails-validation')"></st-editor></div>
                <div class="col-sm-1 angular-editor-edit"
                  (click)="isFrozen ? openEditor('Investigation Details', 'eye') : openEditor('Investigation Details', 'edit')"
                  (keydown.enter)="isFrozen ? openEditor('Investigation Details', 'eye') : openEditor('Investigation Details', 'edit')">
                  <i *ngIf="!isFrozen" class="far fa-edit"></i>
                  <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div><label for="email">Investigation Technique</label></div>
              <mat-select matInput placeholder="Select"
                [(ngModel)]="qualityService.dvPageAllDropdownValues.investigationTechnique" [disabled]="isFrozen"
                (closed)="investigationTechniqueSearchText=''" (click)="focusSearch('focus-technique')"
                (keydown.enter)="focusSearch('focus-technique')"
                [ngClass]="{'odd-item-mat-select':isTechniqueOdd==qualityService.dvPageAllDropdownValues.investigationTechnique}">
                <input type="search" id="focus-technique" class="dropdownsearchstyle"
                  [(ngModel)]="investigationTechniqueSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option
                  *ngFor="let item of investigationTechniqueDropdown| assessmentSearch :investigationTechniqueSearchText"
                  (onSelectionChange)="onDvInvestigationTechniqueSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
              <div class="detail-menu-container">
                <div *ngIf="getAllInvestigationTemplate.length!=0">
                  <div class="upload-text-container">
                    <span> Download Template </span>
                    <div class="upload-template-container">
                      <img class="upload-template-image" src="../../../assets/img/pdf-template.png" alt="file"
                        *ngIf="getAllInvestigationTemplate[0].templateExtn=='pdf'">
                      <img class="upload-template-image" src="../../../assets/img/xls-template.png" alt="file"
                        *ngIf="getAllInvestigationTemplate[0].templateExtn=='xlsx' || getAllInvestigationTemplate[0].templateExtn=='xls'">
                      <img class="upload-template-image" src="../../../assets/img/doc-template.png" alt="file"
                        *ngIf="getAllInvestigationTemplate[0].templateExtn=='docx'">
                    </div>
                    <span>{{ getAllInvestigationTemplate[0].templateName }}.{{
                      getAllInvestigationTemplate[0].templateExtn }}</span>
                  </div>
                  <div class="upload-buttons-container">
                    <div class="download-icon-continer" (click)="downloadTemplates(getAllInvestigationTemplate)"
                      (keydown.enter)="downloadTemplates(getAllInvestigationTemplate)" matTooltip="Download">
                      <i class="fa-solid fa-download"></i>
                    </div>
                    <div class="upload-icon-continer" matTooltip="Upload" *ngIf="!isFrozen">
                      <input class="upload-input-value" (change)="uploadDocuments($event)" type="file" name="myfile"
                        title="" [disabled]="isFrozen" />
                      <i class="fa-solid fa-upload"></i>
                    </div>
                  </div>
                </div>
                <div class="taskDocuments-container" *ngIf="getQmsTaskDocumentsVwDetails.length!=0">
                  <div class="upload-text-container">
                    <span> Executed Template </span>
                    <div class="upload-template-container">
                      <img class="upload-template-image" src="../../../assets/img/pdf-template.png" alt="file"
                        *ngIf="getQmsTaskDocumentsVwDetails[0].documentExtn=='pdf'">
                      <img class="upload-template-image" src="../../../assets/img/xls-template.png" alt="file"
                        *ngIf="getQmsTaskDocumentsVwDetails[0].documentExtn=='xlsx' || getQmsTaskDocumentsVwDetails[0].documentExtn=='xls'">
                      <img class="upload-template-image" src="../../../assets/img/doc-template.png" alt="file"
                        *ngIf="getQmsTaskDocumentsVwDetails[0].documentExtn=='docx'">
                    </div>
                    <span>{{ getQmsTaskDocumentsVwDetails[0].documentName }}.{{
                      getQmsTaskDocumentsVwDetails[0].documentExtn }}</span>
                  </div>
                  <div class="upload-buttons-container">
                    <div class="download-icon-continer" (click)="downloadTemplates(getQmsTaskDocumentsVwDetails)"
                      (keydown.enter)="downloadTemplates(getQmsTaskDocumentsVwDetails)" matTooltip="Download">
                      <i class="fa-solid fa-download"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 field-styles1" *ngIf="visibleInvestigationTechniqueIfOthers">
              <div class="row"><label id="investigationTechniqueIfOthers-validation"
                  for="email">{{dynamicLabel['INVESTIGATION_TECHNIQUE_IF_OTHERS'].fieldName}}<span
                    class="mandatory-symbol">*</span> </label></div>
              <div class="row">
                <div class="hideToolbar col-sm-11"><st-editor [disabled]="isFrozen"
                    [(ngModel)]="qualityService.activity.investigationTechniqueIfOthers" [config]="config"
                    [spellcheck]="true" (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange($event,'investigationTechniqueIfOthers-validation')"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (click)="isFrozen ? openEditor('Investigation Technique If Others', 'eye') : openEditor('Investigation Technique If Others', 'edit')"
                  (keydown.enter)="isFrozen ? openEditor('Investigation Technique If Others', 'eye') : openEditor('Investigation Technique If Others', 'edit')">
                  <i *ngIf="!isFrozen" class="far fa-edit"></i>
                  <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
          </div>
          <br><br>
          <div>
            <app-dv-participants [isDvDisabled]="isFrozen"></app-dv-participants>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Preliminary Actions" *ngIf="message.showPreActionsTab && tabPage=='Preliminary Actions'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1.8" cy="10" r="1.5" stroke="#0F3659"
                [ngStyle]="{strokeWidth: selectedTab == 'Preliminary Actions' ? '2' : '1.2'}" />
              <path d="M4.2 9H6.6L8.3 4.5L10.8 13.5L12 9H15.5" stroke="#0F3659" stroke-linecap="round"
                stroke-linejoin="round" [ngStyle]="{strokeWidth: selectedTab == 'Preliminary Actions' ? '2' : ''}" />
            </svg> &nbsp;
            <span>Preliminary Actions</span>
          </span>
        </ng-template>
        <div class="form-template ActivityPage" id="Actions" style="margin-top:1%;">
          <app-pre-actions *ngIf="selectedTab === 'Preliminary Actions'" [activityData]=" true"></app-pre-actions>
        </div>
      </mat-tab>

      <mat-tab label="Actions" *ngIf="message.showActionSection && tabPage=='Actions'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 8.99947H5.6L7.4364 3L11.3944 15.6L12.7913 8.99947H16.4" stroke="#0F3659"
                stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'Actions' ? '2' : ''}" />
            </svg>
          </span>&nbsp;
          <span>Actions</span>
        </ng-template>
        <div class="form-template ActivityPage" *ngIf="message.showActionSection" style="margin-top:1%;">
          <app-actions *ngIf="selectedTab === 'Actions'" (valueChange)="on_action_emit($event)"
            [activityData]="true"></app-actions>
        </div>
      </mat-tab>

      <mat-tab label="Workflow" *ngIf="parallelWorkflowList?.length>0 && tabPage=='Parallel Workflow'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                fill="#0F3659" stroke="#0F3659"
                [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
            </svg> </span>&nbsp;
          <span>Parallel Workflow</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Workflow" style="margin-top:1%;">
          <app-parallel-workflow *ngIf="selectedTab === 'Workflow'" [showGrid]="true"></app-parallel-workflow>
        </div>
      </mat-tab>

      <mat-tab label="Documents" *ngIf="message.showDocumentSection && tabPage=='Files'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.2501 1.80005V4.50005C11.2501 4.99711 11.6531 5.40005 12.1501 5.40005H14.8501M6.30014 5.40005H8.10014M6.30014 8.10005H11.7001M6.30014 10.8H11.7001M13.5001 3.15005C13.0996 2.79165 12.6839 2.36658 12.4215 2.09051C12.2469 1.9068 12.0057 1.80005 11.7522 1.80005H4.94993C3.95582 1.80005 3.14993 2.60593 3.14993 3.60004L3.14986 14.4C3.14985 15.3941 3.95573 16.2 4.94985 16.2L13.0499 16.2C14.044 16.2 14.8499 15.3942 14.8499 14.4001L14.8501 4.85842C14.8501 4.62829 14.7623 4.40708 14.6026 4.2414C14.3073 3.93503 13.8141 3.43094 13.5001 3.15005Z"
                stroke="#005C8A" [ngStyle]="{strokeWidth: selectedTab == 'Documents' ? '2' : ''}" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>&nbsp;
          <span>Files</span>
        </ng-template>
        <div class="form-template ActivityPage" *ngIf="message.showDocumentSection" id="Documents"
          style="margin-top:1%;">
          <app-task-documents (valueChange)="on_documents_emit($event)" *ngIf="selectedTab === 'Documents'"
            [activity]="this.objForDocuments"></app-task-documents>
        </div>
      </mat-tab>

      <mat-tab label="Reviewer/Approver"
        *ngIf="message.showReviewApproveSection && !isStageUsersSkipped && tabPage=='Reviewer/Approver'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.72486 16.2H4.12485C3.13074 16.2 2.32485 15.3941 2.32486 14.4L2.32493 3.60004C2.32494 2.60593 3.13082 1.80005 4.12493 1.80005H12.2251C13.2192 1.80005 14.0251 2.60594 14.0251 3.60005V8.55005M10.4251 13.65L12.0751 15.3L15.6751 11.6999M5.47514 5.40005H10.8751M5.47514 8.10005H10.8751M5.47514 10.8H8.17514"
                stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'Reviewer/Approver' ? '2' : ''}" />
            </svg>
          </span>&nbsp;
          <span>Reviewer/Approver</span>
        </ng-template>
        <div class="form-template ActivityPage" *ngIf="message.showReviewApproveSection" id="Reviewers/Approvers"
          style="margin-top:1%;">
          <app-stageusers *ngIf="selectedTab === 'Reviewer/Approver'" (valueChange)="on_stageUser_emit($event)"
            [activityData]="this.qualityService.activity"></app-stageusers>
        </div>
      </mat-tab>

      <mat-tab label="Effectiveness Check" *ngIf="message.showEffectiveSection && tabPage=='Effectiveness Check'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.7 7.19981L7.67277 10.7998L6.3 9.57266M16.2 4.4998L16.2 13.4999C16.2 14.9911 14.9912 16.1999 13.5 16.1999H4.5C3.00883 16.1999 1.8 14.9911 1.8 13.4999V4.4998C1.8 3.00864 3.00883 1.7998 4.5 1.7998H13.5C14.9912 1.7998 16.2 3.00864 16.2 4.4998Z"
                stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'Effectiveness Check' ? '2' : ''}" />
            </svg>
          </span>&nbsp;
          <span>Effectiveness Check</span>
        </ng-template>
        <div class="form-template ActivityPage" *ngIf="message.showEffectiveSection" id="Effectiveness Check"
          style="margin-top:1%;">
          <app-tasks-ec (valueChange)="on_effectiveness_emit($event)" *ngIf="selectedTab === 'Effectiveness Check'"
            [activityData]="true"></app-tasks-ec>
        </div>
      </mat-tab>

      <mat-tab label="Extension" *ngIf="message.showExtensionSection && tabPage=='Extension'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                fill="#0F3659" stroke="#0F3659"
                [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
            </svg>
          </span>&nbsp;
          <span>Extension</span>
        </ng-template>
        <div class="form-template ActivityPage" *ngIf="message.showExtensionSection" id="Extensions"
          style="margin-top:1%;">
          <app-task-extensions (extension)="on_extension_emit($event)" *ngIf="selectedTab === 'Extension'"
            [activityData]="true"></app-task-extensions>
        </div>
      </mat-tab>

      <mat-tab label="Dependency" *ngIf="message.showDependancySection && tabPage=='Dependency'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.05 7.36653L16.2 8.98115L8.99999 12.6717L1.79999 8.98115L5.00756 7.33702M13.05 10.8946L16.2 12.5092L8.99999 16.1998L1.79999 12.5092L5.00756 10.8651M8.99999 1.7998L16.2 5.49036L8.99999 9.18092L1.79999 5.49036L8.99999 1.7998Z"
                stroke="#0F3659" [ngStyle]="{strokeWidth: selectedTab == 'Dependancy' ? '2' : ''}"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>&nbsp;
          <span>Dependency</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Dependency" style="margin-top:1%;">
          <app-quality-dependencies *ngIf="selectedTab === 'Dependency'"></app-quality-dependencies>
        </div>
      </mat-tab>

      <mat-tab label="Risk Assessment" *ngIf="message.showRiskTab  && tabPage=='Risk Assessment'">
        <ng-template mat-tab-label>
          <span>
            <img src="../../assets/img/warning (1).png" alt="tasks" width="20" height="20" class="ng-star-inserted">
          </span>&nbsp;
          <span>Risk Assessment</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Risk Assessment" style="margin-top:1%;">
          <app-risk [pagename]="'activity'" *ngIf="selectedTab === 'Risk Assessment'"></app-risk>
        </div>
      </mat-tab>

      <mat-tab label="Notifications" *ngIf="tabPage=='Notifications' && isAdditionalTabUser">
        <ng-template mat-tab-label>
          <span><i class="fa-solid fa-bell" style="font-size: 20px;"></i></span>&nbsp;
          <span>Notifications</span>
        </ng-template>
        <div class="form-template ActivityPage" style="margin-top:1%;">
          <app-activity-notifications *ngIf="selectedTab === 'Notifications'"></app-activity-notifications>
        </div>
      </mat-tab>

      <mat-tab label="History" *ngIf="tabPage=='History'&& isAdditionalTabUser">
        <ng-template mat-tab-label>
          <span><i class="fa-solid fa-clock-rotate-left" style="font-size: 20px;"></i></span>&nbsp;
          <span>History</span>
        </ng-template>
        <div class="form-template ActivityPage" style="margin-top:1%;">
          <app-task-history *ngIf="selectedTab === 'History'"></app-task-history>
        </div>
      </mat-tab>
    </div>
  </mat-tab-group>
</div>

<ng-template #openExportReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Choose Report Template </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer1">
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="reportTemplate-validation" for="email">Report Template</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">

        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplateValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onPdfDetailValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportTemplateDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onPdfDetailValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email" id="ReportValueSelect-validation">Report Logo</label>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Attach all documents?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="attachAllDocuments">
          <ng-container *ngIf="attachAllDocuments; else noattachAllDocuments">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noattachAllDocuments>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="attachAllDocuments">

      <label for="email">Attachments to the report are limited to PDF, DOC, or DOCX formats.</label>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="exportReportGenerateFuntion()">
      <i class="fas fa-check"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="exportReportCancelPopupFuntion()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
        [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{qualityService.moduleFullName}}&nbsp; Topics </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>
<app-top-navigation [hidden]="true"></app-top-navigation>
<app-add-parallel-workflows (valueEmitter)="onworkflowChildValueEmitted()"
  *ngIf="addworkflow"></app-add-parallel-workflows>

<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>


<app-moduletype (valueEmitter)="onModuleTypeEmitted($event)" [parentData]="moduleTypeData"></app-moduletype>
<app-quality-dependents></app-quality-dependents>
